import React from "react";
import { IoIosSchool } from "react-icons/io";
import { RiBriefcase4Line } from "react-icons/ri";
import {
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiReact,
  SiSap,
  SiMicrosoftexcel,
  SiNodedotjs,
  SiTypescript,
} from "react-icons/si";
import { TbSql } from "react-icons/tb";
import { BsGit } from "react-icons/bs";
import { FaSass } from "react-icons/fa";

export const experienceInfo = [
  `Completed four Udemy courses HTML, CSS (SASS, Flexbox, Grid), JavaScript, and React, and built 10+ projects.
  Conducted a case study project on 'React vs. Vanilla JavaScript' as part of personal development.
  Skilled in implementing the Model-View-Controller (MVC) architecture in JavaScript and creating UML diagrams.
  Experienced in writing React components using context and hooks, APIs, and custom hooks.
  Demonstrated proficiency in task management, meeting deadlines, efficiency and market analysis, and getting  knowledge and insights by fostering a collaborative team environment during a three-year experience in a large corporation.`,
];

export const skillsData = [
  {
    id: 1,
    name: "JavaScript",
    icon: <SiJavascript className="skills-icon js" />,
  },
  { id: 2, name: "React", icon: <SiReact className="skills-icon react" /> },
  { id: 3, name: "HTML5", icon: <SiHtml5 className="skills-icon html" /> },
  { id: 4, name: "CSS3", icon: <SiCss3 className="skills-icon css" /> },
  {
    id: 5,
    name: "TypeScript",
    icon: <SiTypescript className="skills-icon ts" />,
  },
  { id: 6, name: "NodeJS", icon: <SiNodedotjs className="skills-icon node" /> },
  { id: 7, name: "Sass", icon: <FaSass className="skills-icon sass" /> },
  { id: 8, name: "Git", icon: <BsGit className="skills-icon git" /> },
  { id: 9, name: "SQL", icon: <TbSql className="skills-icon sql" /> },
  { id: 10, name: "SAP", icon: <SiSap className="skills-icon sap" /> },
  {
    id: 11,
    name: "Excel",
    icon: <SiMicrosoftexcel className="skills-icon exl" />,
  },
];

const educationData = [
  {
    id: 1,
    title: "Udemy course - Frontend development",
    date: "Dec 2021 - Jan 2023",
    city: "Belgrade, Serbia",
    info: "HTML, CSS, JavaScript, React",
  },

  {
    id: 4,
    title: `Bachelor's Degree`,
    place: "University of Belgrade, Faculty of Economics",
    date: "Sep 2013 - Sep 2018",
    city: "Belgrade, Serbia",
    info: "International Economics and Foreign Trade",
  },
  {
    id: 3,
    title: "MC Office - Excel  course",
    place: "University of Belgrade, Faculty of Economics",
    date: "Mar 2016 - June 2016",
    city: "Belgrade, Serbia",
    info: "Advanced knowlage of MC Office and finance and analysis using Excel tools",
  },
  {
    id: 5,
    title: "Economic-trade school",
    date: "Sep 2009 - Jun 2013",
    city: "Bor, Serbia",
    info: "Finance administrator- experimental modul",
  },
];

const workExperienceData = [
  {
    id: "exp-1",
    title: "IT consultant",
    company: "Flaner",
    city: "Belgrade, Serbia",
    date: "Okt 2024 - present",
    info: [
      "Participated in the implementation and testing of SAP FI and MM modules, collaborating with senior consultants and business users.",
      "Performed basic configuration in FI and MM modules, resultingin a 10% increase in process efficiency.",
      "Created user documentation and provided daily support,reducing technical issue reports by 15%.",
    ],
  },
  {
    id: "exp-2",
    title: "Frontend Software Engineer",
    company: "PlanIt",
    city: "Belgrade, Serbia",
    date: "Sep 2023 - Jul 2024",
    info: [
      "PresentContributed to develop an advanced informationmanagement platform that consolidates and synchronizesnotifications and services for city residents, ensuring timely andefficient access to essential information.",
      "Collaborated with co-owners and designer to define featuresand build the MVP.",
      "Created the frontend using React and SCSS, with a strongemphasis on user experience and mobile-friendly designJunior",
    ],
  },
  {
    id: "exp-3",
    title: "Frontend Development Intern (UI)",
    company: "Grid Dynamics",
    city: "Belgrade, Serbia",
    date: "Feb 2023 - Jul 2023",
    info: [
      "Assisted in the development of a responsive demoeCommerce website using React, contributing to seamlessintegration and performance.",
      "Worked closely with designers and backend developers tosupport alignment between design and functionality.",
      "Applied React to improve user experience and support efficient component-based development.",
      "Participated in debugging processes to help ensure cross-browser compatibility and solid performance.",
    ],
  },
  {
    id: "exp-4",
    title: "Coordinator for Procurement of Material and Equipment for Rafinery",
    company: "NIS Gazprom Neft",
    city: "Belgrade, Serbia",
    date: "Nov 2019 - Jan 2023",
    info: [
      "Evaluated suppliers for quality and performance, maintained an approved vendor list, and researched new suppliers, products, and technologies.",
      "Analyzed market trends, negotiated contracts and supplier terms, and identified cost-saving opportunities.",
      "Used analytics to track procurement performance, optimize spending, and enhance overall operational efficiency.",
      "Led end-to-end procurement processes in SAP, sourcing essential materials while ensuring compliance and strategic alignment.",
    ],
  },
  {
    id: "exp-5",
    title: "High school internship",
    company: `Virtual Ltd. 'Black&White'`,
    city: "Bor, Serbia",
    date: "Sep 2009 - May 2013",
    info: [
      `Financial Management; Accounting; Marketing; Sales and Purchasing;
    Legal Foundation and legal liquidation of Virtual Ltd. "Black&White; Gathering, managing and
    investing virtual funds; Financial projections; Bookkeeping; Managing balance sheet, profit
    and loss sheet, cash flow sheet; Cost analysis; Market research; Swot analysis; Catalogs;`,
    ],
  },
];

export const componentBlockData = [
  {
    id: 1,
    classDiv: "exp-edu--container_block",
    classHeader: "exp-edu--container_block-header",
    title: "experience",
    iconHeader: (
      <RiBriefcase4Line className="exp-edu--container_block-header--icon" />
    ),
    data: workExperienceData,
  },
  {
    id: 2,
    classDiv: "exp-edu--container_block",
    classHeader: "exp-edu--container_block-header",
    title: "education",
    iconHeader: (
      <IoIosSchool className="exp-edu--container_block-header--icon" />
    ),
    data: educationData,
  },
];
